/*
 * File: index.ts
 * File Created: 2023-11-27 03:14:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-02-25 07:53:25
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { RegisterRouter as $, StringHelper } from "@/../core";

import { RegisterLoginRouter } from "@/../core";
// import Login from "@root/components/views/login/login";
import Login from "./login/login";
import FailedJob from "./AdminPages/FailedJob/FailedJob.vue";
import Terms from "./Terms/Terms.vue";
import PaymentSuccess from "./PaymentSuccess/PaymentSuccess.vue";
import Maintainance from "./Maintainance/Maintainance.vue";
import appConfig from "@/config/default/application";
// import CustomAdminLogin from "@/components/login/admin-login/admin-login";

const prefix = "";
const dirPath = "AdminPages/";
const config = { dirPath };

type IDeclareRouteConfig = Partial<
    Pick<
        IRegisterRouter,
        "icon" | "name" | "path" | "allow" | "deny" | "default" | "container"
    > & {
        dirPath: string;
    }
>;
const declareRoute = (modelName: string, config: IDeclareRouteConfig) => {
    const dasherize = StringHelper.dasherize(modelName);
    const { dirPath: oDirPath } = config;

    /// require index (IQuick)
    let index: IQuickUnit | undefined = UIQuick.getInstance(modelName);
    const name = config.name ?? index?.title ?? null;

    /// require instance
    const instance = require(`./${oDirPath ?? ""}${modelName}/${modelName}.vue`);
    $({
        icon: index?.icon,
        ...config,
        // default: undefined,
        path: `${prefix}/${dasherize}`,
        name,
    })(instance.default);

    /// require detail
    try {
        const detail = require(`./${oDirPath ?? ""}${modelName}/${modelName}Detail.vue`);
        $({
            icon: index?.icon,
            ...config,
            path: `${prefix}/${dasherize}/:id`,
            name: `{${name}}{w_Detail}`,
        })(detail.default);
    } catch (e) {}
};

const maintainanceDate = appConfig?.maintainance;
const enableMaintainance =
    maintainanceDate instanceof Date && !Number.isNaN(maintainanceDate.getTime());

if (enableMaintainance) {
    RegisterLoginRouter({ name: "w_Login", path: `${prefix}/login`, container: null })(
        Maintainance,
    );
    $({
        path: `${prefix}/maintainance`,
        name: "Maintainance",
        allow: true,
        container: null,
    })(Maintainance);
    $({
        path: `${prefix}/maintainance/login`,
        name: "MaintainanceLogin",
        allow: true,
        container: null,
    })(Login);
} else {
    RegisterLoginRouter({ name: "w_Login", path: `${prefix}/login`, container: null })(Login);
}

$({
    path: `${prefix}/terms`,
    name: "Terms",
    allow: true,
    container: null,
})(Terms);

$({
    path: `${prefix}/payment-success`,
    name: "PaymentSuccess",
    allow: true,
    container: null,
})(PaymentSuccess);

/// removed the main route
// $({ path: "/", name: "Main", redirect: `${prefix}/home` })();
$({ path: "/", name: "Main", redirect: `${prefix}/translation-job` })();

/// User
$({
    path: `${prefix}/user-management`,
    name: "w_UserManagement",
    icon: "fa-solid fa-user-tie",
    redirect: `${prefix}/user`,
    allow: { uris: "/user" },
})();
declareRoute("User", {
    ...config,
    allow: {
        uris: "/user",
    },
});
declareRoute("Account", {
    ...config,
    allow: { uris: "/account", method: "Patch" },
});
declareRoute("LoginLog", {
    ...config,
    allow: { uris: "/login-log", method: "Patch" },
});

/// Org & Member
$({
    path: `${prefix}/organization-management`,
    name: "w_MenuOrgAndMember",
    icon: "fa-solid fa-briefcase",
    redirect: `${prefix}/organization`,
})();
declareRoute("Organization", config);
declareRoute("Membership", config);

/// Billing
$({
    path: `${prefix}/billing`,
    name: "w_MenuBilling",
    icon: "fa-solid fa-wallet",
    redirect: `${prefix}/wallet`,
})();
declareRoute("Wallet", config);
declareRoute("Ledger", config);

/// Promo & Redeem
$({
    path: `${prefix}/promo-redeem`,
    name: "w_MenuPromoAndRedeem",
    icon: "fa-solid fa-money-check-dollar",
    redirect: `${prefix}/promo`,
    allow: { uris: "/promotion-code" },
})();
declareRoute("PromotionCode", {
    ...config,
    allow: { uris: "/promotion-code" },
});
$({
    path: `${prefix}/redemption`,
    name: "w_MenuRedemption",
    icon: "fa-solid fa-money-bill-transfer",
})();

/// Translation
declareRoute("TranslationJob", config);
declareRoute("FailedJob", {
    ...config,
    allow: { roles: ["ADMIN"] },
});
// $({
//     path: `${prefix}/translate-error`,
//     name: "w_MenuTranslateError",
//     icon: "fa-solid fa-circle-exclamation",
//     allow: { uris: "/translation-job", method: "Patch" },
// })(FailedJob);

// $({
//     path: `${prefix}/translation`,
//     name: "w_MenuTranslation",
//     icon: "fa-solid fa-earth-asia",
//     redirect: `${prefix}/translation-task`,
// })();
// $({
//     path: `${prefix}/translation-task`,
//     name: "w_MenuTranslateTask",
//     icon: "fa-solid fa-earth-asia",
// })();
// $({
//     path: `${prefix}/translate-content`,
//     name: "w_MenuTranslateTaskContent",
//     icon: "fa-solid fa-language",
// })();

// /// System
// declareRoute("User", "w_UserManagement", config);
// $({
//     path: `${prefix}/device`,
//     name: "w_DeviceManagement",
//     icon: "fa-solid fa-satellite-dish",
// })();
// /// warrant
// declareRoute("Warrant", "w_WarrantManagement", config);
// /// status
// import Status from "./AdminPages/Status/Status.vue";
// $({
//     path: `${prefix}/status`,
//     name: "w_SystemHealthCheck",
//     icon: "fa-solid fa-signal",
// })(Status);
// $({
//     path: `${prefix}/license`,
//     name: "w_LicenseManagement",
//     icon: "fa-solid fa-id-card",
// })();
// $({
//     path: `${prefix}/system`,
//     name: "w_SystemConfiguration",
//     icon: "fa-brands fa-apple",
// })();

// /// Log
// import Log from "./AdminPages/Log/Log.vue";
// $({
//     path: `${prefix}/log`,
//     name: "w_Log",
//     icon: "fa-solid fa-table",
// })(Log);

/// Demo
import Demo from "./AdminPages/Demo/Demo.vue";
$({ path: `${prefix}/demo`, name: "Demo", icon: "fa-solid fa-desktop" })(Demo);

/// Demo / Card
import DemoCard from "./AdminPages/Demo/Card/Card.vue";
$({ path: `${prefix}/demo/card`, name: "Card" })(DemoCard);

/// Demo / Form
$({ path: `${prefix}/demo/form`, name: "Form" })();
import DemoFormCore from "./AdminPages/Demo/Form/FormCore/FormCore.vue";
$({ path: `${prefix}/demo/form/core`, name: "Form Core" })(DemoFormCore);
import DemoFormElements from "./AdminPages/Demo/Form/FormElements/FormElements.vue";
$({ path: `${prefix}/demo/form/elements`, name: "Form Elements" })(DemoFormElements);

/// Demo / Input
import DemoInput from "./AdminPages/Demo/Input/Input.vue";
$({ path: `${prefix}/demo/input`, name: "Input" })(DemoInput);

/// Demo / Input
import DemoTable from "./AdminPages/Demo/Table/Table.vue";
$({ path: `${prefix}/demo/table`, name: "Table" })(DemoTable);

/// Demo / Button
import DemoButton from "./AdminPages/Demo/Button/Button.vue";
$({ path: `${prefix}/demo/button`, name: "Button" })(DemoButton);

/// Demo / Utilities
import DemoUtilities from "./AdminPages/Demo/Utilities/Utilities.vue";
import { IQuickUnit, UIQuick } from "@root/core/utilities/quick-helper";
import { IRegisterRouter } from "@root/core/router/core";
$({ path: `${prefix}/demo/utilities`, name: "Utilities" })(DemoUtilities);
